import { RouterModule, Routes } from '@angular/router';
import { SubmitedModalComponent } from './submited-modal.component';
import { NgModel } from '@angular/forms';
import { NgModule } from '@angular/core';

const routes: Routes = [{ path: '', component: SubmitedModalComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SubmitedModalRoutingModule {}
